import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { GpaScale } from "@/types/dashboard.types";

const GpaScaleData = ({ data }: { data: GpaScale[] }) => {
  const hasGrade = data.some((item) => item.Grade && item.Grade.trim() !== "");
  const hasScale = data.some((item) => item.Scale && item.Scale.trim() !== "");
  const hasGradeDescription = data.some(
    (item) =>
      item["Grade Description"] && item["Grade Description"].trim() !== ""
  );
  const hasNotes = data.some((item) => item.Notes && item.Notes.trim() !== "");
  const hasScale2 = data.some(
    (item) => item["Scale 2"] && item["Scale 2"].trim() !== ""
  );
  const hasUSGradePoints = data.some(
    (item) => item["US Grade Points"] && item["US Grade Points"].trim() !== ""
  );
  return (
    <Table id="gpa-scale-table">
      <TableHeader>
        <TableRow>
          {hasGrade && <TableHead>Grade</TableHead>}
          {hasScale && <TableHead>Scale</TableHead>}
          {hasScale2 && <TableHead>Scale 2</TableHead>}
          {hasGradeDescription && <TableHead>Grade Description</TableHead>}
          {hasNotes && <TableHead>Notes</TableHead>}
          {hasUSGradePoints && (
            <TableHead className="text-center">U.S Grade Points</TableHead>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            {hasGrade && <TableCell>{item.Grade?.trim()}</TableCell>}
            {hasScale && <TableCell>{item.Scale}</TableCell>}
            {hasScale2 && <TableCell>{item["Scale 2"]}</TableCell>}
            {hasGradeDescription && (
              <TableCell>{item["Grade Description"]}</TableCell>
            )}
            {hasNotes && <TableCell>{item.Notes}</TableCell>}
            {hasUSGradePoints && (
              <TableCell className="text-center">
                {item["US Grade Points"]}
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default GpaScaleData;

export function EmptyGpaScaleData() {
  return (
    <Table id="gpa-scale-table">
      <TableHeader>
        <TableRow>
          <TableHead>Grade</TableHead>
          <TableHead>Scale</TableHead>
          <TableHead>Scale 2</TableHead>
          <TableHead>Grade Description</TableHead>
          <TableHead>Notes</TableHead>

          <TableHead className="text-center">U.S Grade Points</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>X</TableCell>
          <TableCell>X</TableCell>
          <TableCell>X</TableCell>
          <TableCell>X</TableCell>
          <TableCell>X</TableCell>
          <TableCell className="text-center">X</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}
